import { useState, useEffect } from 'react';

export const useFormPopup = () => {
  const [isFormPopupOpen, setIsFormPopupOpen] = useState(false);

  const openFormPopup = () => {
    setIsFormPopupOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeFormPopup = () => {
    setIsFormPopupOpen(false);
    document.body.style.overflow = 'unset';
  };

  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && isFormPopupOpen) {
        closeFormPopup();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isFormPopupOpen]);

  useEffect(() => {
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  return {
    isFormPopupOpen,
    openFormPopup,
    closeFormPopup
  };
}; 